import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202506/match-jiangyin/Index.vue')

export const matchJiangyin2025Index: RouteConfig = {
  path: '/activity/202506/match-jiangyin',
  name: 'activity_202506_match_jiangyin',
  component: Index,
  meta: {
    title: '2025年江阴市暑期中小幼 AI 线上趣味赛事',
  },
}

export default [matchJiangyin2025Index]
